// extracted by mini-css-extract-plugin
module.exports = {"boxEntitySubTitle":"BoxSubTitle_boxEntitySubTitle__1PDBJ","subTitleBold":"BoxSubTitle_subTitleBold__5y4K4"};